import anime from 'animejs';
import { measureHeight } from './animations';

const createSlider = (root: HTMLElement) => {
	let currentSlide = 0;
	let isAnimating = false;

	const images = root.querySelectorAll<HTMLElement>('[data-slider-image]');
	const slideContents = root.querySelectorAll<HTMLTemplateElement>(
		'[data-slider-slide-content]',
	);

	const content = root.querySelector<HTMLElement>('[data-slider-content]');
	if (!content) return;

	const dots = root.querySelectorAll<HTMLElement>('[data-slider-slide-dot]');
	const prevBtn = root.querySelector<HTMLElement>('[data-slider-prev]');
	const nextBtn = root.querySelector<HTMLElement>('[data-slider-next]');

	const goToSlide = (i: number, forceDirection?: 'prev' | 'next') => {
		if (isAnimating || i === currentSlide || i < 0) return;
		isAnimating = true;

		const prevSlide = currentSlide;
		currentSlide = i;

		const forward = forceDirection
			? forceDirection === 'next'
			: prevSlide < currentSlide;

		const prevVideo = images[prevSlide].querySelector('video');
		const currentVideo = images[currentSlide].querySelector('video');

		let tl = anime.timeline({
			duration: 1000,
			easing: 'easeInOutCubic',
			begin() {
				prevVideo?.pause();
				if (currentVideo) {
					currentVideo.currentTime = 0;
					currentVideo.play();
				}
				images[currentSlide].style.removeProperty('display');
			},
			complete() {
				isAnimating = false;
			},
		});

		tl.add(
			{
				targets: images[prevSlide],
				translateX: [0, forward ? '-100%' : '100%'],
			},
			0,
		);

		tl.add(
			{
				targets: images[currentSlide],
				translateX: [forward ? '100%' : '-100%', 0],
			},
			0,
		);

		const newContent = slideContents[currentSlide]?.content.cloneNode(
			true,
		) as HTMLElement;
		const prevHeight = measureHeight(content);

		content.style.height = prevHeight.height;

		const prevInner = content.querySelector<HTMLElement>(
			'[data-slider-content-inner]',
		);
		content.appendChild<HTMLElement>(newContent);
		const newInner = content.querySelector<HTMLElement>(
			'[data-slider-content-inner]:last-child',
		);

		const newHeight = newInner ? measureHeight(newInner) : prevHeight;

		tl.add(
			{
				targets: prevInner,
				opacity: [1, 0],
				duration: 300,
				complete() {
					prevInner?.parentNode?.removeChild(prevInner);
				},
			},
			0,
		);

		tl.add(
			{
				targets: newInner,
				opacity: [0, 1],
				duration: 700,
			},
			300,
		);

		tl.add(
			{
				targets: content,
				height: [prevHeight.height, newHeight.height],
				begin() {
					content.appendChild(newContent);
				},
				complete() {
					content.style.removeProperty('height');
				},
			},
			0,
		);

		dots.forEach((dot, i) =>
			dot.classList.toggle('plp-slider__dot--active', i === currentSlide),
		);
	};

	dots.forEach((dot, i) => {
		dot.addEventListener('click', () => {
			goToSlide(i);
		});
	});

	prevBtn?.addEventListener('click', () => {
		goToSlide((currentSlide - 1) % images.length, 'prev');
	});

	nextBtn?.addEventListener('click', () => {
		goToSlide((currentSlide + 1) % images.length, 'next');
	});
};

const sliders = document.querySelectorAll<HTMLElement>('[data-slider]');
sliders.forEach(createSlider);
